import { render, staticRenderFns } from "./referralResume.vue?vue&type=template&id=2fd3a44b&scoped=true"
import script from "./referralResume.vue?vue&type=script&lang=js"
export * from "./referralResume.vue?vue&type=script&lang=js"
import style0 from "./referralResume.vue?vue&type=style&index=0&id=2fd3a44b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3a44b",
  null
  
)

export default component.exports